import {
  Accordion,
  Anchor,
  Burger,
  Button,
  Flex,
  Stack,
  Title,
} from "@mantine/core";
import React from "react";
import classes from "../../styles/NavbarMobile.module.css";
import Image from "next/image";
import { NavbarProp } from "@components/hooks/utils/types/propTypes";
import AnimatedLogo from "@components/atoms/AnimatedLogo";

import Link from "next/link";

export default function NavbarMobile({
  opened,
  toggle,
  headerList,
  headerPopover,
}: NavbarProp) {
  const items = (headerList ?? []).map((item, index) => {
    if (item.link) {
      return (
        <Link prefetch={false} key={index} href={item.link} passHref>
          {/* <div className="flex flex-row gap-4">
            <Image src={item.iconPath} height={20} width={20} alt="icon" />
            {item.name}
          </div> */}
          <Accordion
            transitionDuration={10000000}
            classNames={classes}
            chevronSize={0}
          >
            <Accordion.Item key={index} value={item.name}>
              <Accordion.Control
                icon={
                  <Image
                    src={item.iconPath}
                    height={20}
                    width={20}
                    alt="icon"
                  />
                }
              >
                {item.name}
              </Accordion.Control>
            </Accordion.Item>
          </Accordion>
        </Link>
      );
    }
    return (
      <Accordion.Item key={index} value={item.name}>
        <Accordion.Control
          icon={<Image src={item.iconPath} height={20} width={20} alt="icon" />}
        >
          {item.name}
        </Accordion.Control>
        <Accordion.Panel>
          {
            <Stack gap={20}>
              {headerPopover[item.name]?.map((parentLink, index) => {
                return (
                  <Stack gap={8} key={index}>
                    <Anchor href={parentLink.categoryLink}>
                      <Title order={5}>{parentLink.category}</Title>
                    </Anchor>
                    <Stack gap={1} ml={15}>
                      {parentLink.subCategories.map((subCategories, index) => {
                        return (
                          <Anchor
                            key={index}
                            href={subCategories.link}
                            target="_blank"
                            c="white"
                          >
                            {subCategories.text}
                          </Anchor>
                        );
                      })}
                    </Stack>
                  </Stack>
                );
              })}
            </Stack>
          }
        </Accordion.Panel>
      </Accordion.Item>
    );
  });

  return (
    <nav className="relative h-full overflow-y-auto">
      <Flex justify="space-between" px={12} my={22}>
        <AnimatedLogo transparent={true} />
        <Burger
          opened={opened}
          onClick={toggle}
          hiddenFrom="sm"
          size="sm"
          color={opened ? "white" : "black"}
          aria-label="Toggle navigation"
        />
      </Flex>
      <Accordion variant="filled" radius="lg" classNames={classes}>
        {items}
      </Accordion>
      <div className="flex flex-col gap-10 mt-4 items-center relative">
        {/* <Image
          src={"/ethinos-home-page/images/familyPhoto.jpg"}
          height={64}
          width={118}
          alt="India's best health insurance company"
          className="md:w-[100px] md:h-[50px] w-[80%]"
          sizes="100vw"
        /> */}
        {/* <Button
          leftSection={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
              />
            </svg>
          }
          variant="outline"
          radius="xl"
        >
          English
        </Button> */}
      </div>
    </nav>
  );
}
